import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { useTheme } from 'next-themes'
import { useInternalAPI } from '../api/internal-api'

type UseKycTokenParams = {
  isEnabled?: boolean
}

export const useKycToken = ({ isEnabled }: UseKycTokenParams = {}) => {
  const { get } = useInternalAPI()
  const { resolvedTheme } = useTheme()
  const locale = useLocale()

  return useQuery({
    queryKey: ['kyc-token', resolvedTheme, locale],
    queryFn: () => {
      const params = new URLSearchParams()
      if (resolvedTheme) params.append('theme', resolvedTheme)
      if (locale) params.append('locale', locale)
      return get<{ token: string }>(
        `/api/account/kyc-token?${params.toString()}`,
      )
    },
    enabled: isEnabled,
    staleTime: 0, // NOTE: Ensure we fetch a new token every time
    gcTime: 0,
  })
}
